import React, { useEffect } from "react";
import { useCartStore } from "../../../store/useCartStore";

function Total_cart() {
  const { shopping, loading } = useCartStore((state) => state);

  useEffect(() => {
    let item = document.querySelectorAll("#cart .total-cart .item");
    item.forEach((element) => {
      let title = element.querySelector(".title");
      let title_width = title.offsetWidth;
      let price = element.querySelector(".price");
      let price_width = price.offsetWidth;
      let line = element.querySelector(".line");
      let line_width = title_width + price_width;
      line.style.width = "calc(95% - " + line_width + "px)";
    });
  }, []);

  if (loading)
    return (
      <div className="active loading">
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
    );

  if (shopping.total_items < 1)
    return (
      <>
        document.querySelector('.checkout').classList.add('d-none'); return (
        <>
          <svg
            className="m-auto d-block mb-3"
            fill="#ffffff"
            width="100px"
            height="100px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M15.2746538,18 C14.5292972,16.9402308 13.3195004,16.2978292 12,16.2978292 C10.6804996,16.2978292 9.4707028,16.9402308 8.72534624,18 L7.08943782,16.8494333 C8.20545254,15.2626519 10.0224456,14.2978292 12,14.2978292 C13.9775544,14.2978292 15.7945475,15.2626519 16.9105622,16.8494333 L15.2746538,18 Z M14,12 L14,10 L16,10 L16,12 L14,12 Z M8,12 L8,10 L10,10 L10,12 L8,12 Z" />
          </svg>
          <p className="text-center text-white mb-5">سبد خرید شما خالی است.</p>
        </>
        );
      </>
    );
  return (
    <div className="total-cart">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="total-order-price item">
              <p className="title">مجموع سفارش های شما</p>
              <p className="line"></p>
              <p className="price">
                {shopping.total_price}
                <span className="currency">تومان</span>
              </p>
            </div>
            <div className="tax-price item">
              <p className="title">مالیات بر ارزش افزوده (۹٪)</p>
              <p className="line"></p>
              <p className="price">
                {shopping.tax_price}
                <span className="currency">تومان</span>
              </p>
            </div>
            <div className="total-pay-price item">
              <p className="title">هزینه پرداختی</p>
              <p className="line"></p>
              <p className="price">
                {shopping.total_price}
                <span className="currency">تومان</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  // } else {
  //   document.querySelector('.checkout').classList.add('d-none');
  //   return (
  //     <>
  //       <svg className="m-auto d-block mb-3" fill="#ffffff" width="100px" height="100px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  //         <path  d="M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 Z M15.2746538,18 C14.5292972,16.9402308 13.3195004,16.2978292 12,16.2978292 C10.6804996,16.2978292 9.4707028,16.9402308 8.72534624,18 L7.08943782,16.8494333 C8.20545254,15.2626519 10.0224456,14.2978292 12,14.2978292 C13.9775544,14.2978292 15.7945475,15.2626519 16.9105622,16.8494333 L15.2746538,18 Z M14,12 L14,10 L16,10 L16,12 L14,12 Z M8,12 L8,10 L10,10 L10,12 L8,12 Z" />
  //       </svg>
  //       <p className="text-center text-white mb-5">سبد خرید شما خالی است.</p>
  //     </>
  //   );
  // }
}

export default Total_cart;
